import React from 'react'

export const About = React.lazy(() => import('./About').then(({ About }) => ({ default:About })))
